import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import ProjectsContent from '../components/ProjectsContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { api_base_url, base_url} from '../common/Constants';
 
class Projects extends React.Component{
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[6].title}</title>  
                    <meta name="description" content={metas[6].meta_description} />
                    <meta name="keywords" content={metas[6].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'projects'} />
                </Helmet>
                <PageHeader title="Projects" banner="Projects"/>
                <ProjectsContent content={JSON.parse(localStorage.getItem("content"))} projects={JSON.parse(localStorage.getItem("projects"))} project_types={JSON.parse(localStorage.getItem("project_types"))} />  
                <Footer/>
            </div>
       
        )
    }

}
export default Projects;